module.exports = __webpack_public_path__ + "static/media/S2C1.bb0021d9.svg";